import { render } from "./DefaultBtn.vue?vue&type=template&id=23519611"
import script from "./DefaultBtn.vue?vue&type=script&lang=js"
export * from "./DefaultBtn.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\code\\jingcisi\\wx\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__